<template>
  <div class="file-feature">
    <div class="file-image-container">
      <span class="file-extension" v-if="item.attributes.file_ext">{{
        item.attributes.file_ext
      }}</span>
      <img :src="filePlaceholder" />
    </div>
    <h3 class="file-title">{{ item.attributes.name }}</h3>
    <a
      v-if="downloadKeyPromptEnabled"
      class="cloudapp-btn"
      @click="onclick"
      title="Download"
      data-toggle="modal"
      data-target="downloadModal"
      data-testid="file-feature-download"
    >
      Download
    </a>
    <a
      v-else
      :href="genericUrl"
      class="cloudapp-btn"
      title="Download"
      target="_blank"
      data-testid="file-feature-download"
    >
      Download
    </a>
  </div>
</template>

<script>
import filePlaceholder from "./../../../images/file-placeholder.svg";

export default {
  props: {
    item: Object,
    zoomed: Boolean,
    cta: Object,
    downloadKeyPromptEnabled: Boolean,
  },
  computed: {
    genericUrl: function () {
      return this.$root.routes.viewer_download_item_url({
        slug: this.item?.id,
        filename: this.item?.attributes?.name,
        utm_source: "viewer_new",
      });
    },
  },
  data() {
    return {
      filePlaceholder: filePlaceholder,
    };
  },
  methods: {
    onclick() {
      $("#downloadModal").modal();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../packs/application.scss";

.file-feature {
  text-align: center;
}
</style>
